var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1386 15.4638C30.1386 23.7045 23.4584 30.3849 15.2178 30.3849C6.97718 30.3849 0.296875 23.7045 0.296875 15.4638C0.296875 7.22327 6.97718 0.542969 15.2178 0.542969C23.4583 0.542969 30.1386 7.22327 30.1386 15.4638Z",
    fill: "#26337A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6845 18.8766H9.05757L7.83748 14.4014C7.77958 14.1954 7.65658 14.0134 7.47568 13.9277C7.02448 13.712 6.52708 13.5406 5.98438 13.4541V13.2816H8.60547C8.96727 13.2816 9.23848 13.5406 9.28348 13.8412L9.91647 17.0697L11.5428 13.2816H13.1247L10.6845 18.8766ZM14.0292 18.8766H12.4926L13.7577 13.2813H15.2943L14.0292 18.8766ZM17.2824 14.8315C17.3274 14.53 17.5989 14.3578 17.9154 14.3578C18.4128 14.3146 18.9546 14.4011 19.4067 14.616L19.6779 13.4111C19.2314 13.2428 18.7564 13.155 18.2769 13.1523C16.7859 13.1523 15.7005 13.9274 15.7005 15.0031C15.7005 15.8212 16.4691 16.251 17.0118 16.5097C17.5989 16.7679 17.8248 16.9401 17.7798 17.1983C17.7798 17.5854 17.3274 17.7579 16.8762 17.7579C16.3335 17.7579 15.7911 17.6287 15.2943 17.4132L15.0231 18.6187C15.5658 18.8333 16.1526 18.9198 16.6953 18.9198C18.3675 18.9625 19.4067 18.188 19.4067 17.0261C19.4067 15.5624 17.2824 15.4768 17.2824 14.8315ZM24.7845 18.8766L23.5644 13.2813H22.2534C21.9822 13.2813 21.711 13.4538 21.6204 13.7117L19.3614 18.8766H20.943L21.2586 18.0591H23.2023L23.3832 18.8766H24.7845ZM22.4799 14.7882L22.9314 16.8969H21.666L22.4799 14.7882Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/VisaCard.fdc827fe6bff2c255e11efadc7bba786.svg";
export { ForwardRef as ReactComponent };